(function () {
  if (window.artbitePickupCheckout) return;
  const privateFields = ['Fulfillment Method', 'Pickup Name', 'Pickup Phone',
    'Recipient Name', 'Recipient First Name', 'Recipient Last Name', 'Recipient Company', 'Recipient Phone', 'Recipient Address', 'Recipient Unit',
    'Recipient City', 'Recipient Province', 'Recipient Country', 'Recipient Postal Code',
    'Delivery Date', 'Delivery Instructions', 'Card Message', 'Sender Name', 'Sender First Name', 'Sender Last Name', 'Sender Phone'];
  window.artbitePrepareCheckout = async function (attributes) {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: Object.fromEntries(privateFields.map((key) => [key, ''])) })
    });
    if (!response.ok) throw new Error('Could not update cart');
    const cart = await response.json();
    privateFields.forEach((key) => { delete cart.attributes[key]; });
    cart.attributes = { ...cart.attributes, ...attributes };
    return cart;
  };
  function resetForms() {
    document.querySelectorAll('#artbite-pickup-form, #artbite-delivery-form').forEach((form) => {
      form.reset();
      form.querySelectorAll('input:not([type="hidden"]):not([readonly]), textarea').forEach((field) => {
        field.value = '';
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      });
      form.querySelectorAll('[data-delivery-error]').forEach((error) => { error.hidden = true; });
      form.querySelectorAll('[type="submit"]').forEach((button) => {
        button.disabled = false;
        if (button.dataset.originalText) button.textContent = button.dataset.originalText;
      });
      form.querySelectorAll('[data-artbite-address-search]').forEach((host) => {
        const replacement = host.cloneNode(true);
        replacement.querySelector('[data-artbite-search-widget]').replaceChildren();
        replacement.querySelector('[data-artbite-search-status]').textContent = '';
        const button = replacement.querySelector('[data-artbite-search-start]');
        button.hidden = false;
        button.disabled = false;
        host.replaceWith(replacement);
      });
    });
  }
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('#artbite-pickup-form, #artbite-delivery-form')) return;
    const button = event.target.querySelector('[type="submit"]');
    if (button && !button.dataset.originalText) button.dataset.originalText = button.textContent;
  }, true);
  const draftKey = 'artbite-form-draft-v1';
  const draftTTL = 2 * 60 * 60 * 1000;
  const formSelector = '#artbite-pickup-form, #artbite-delivery-form';
  const fieldSelector = 'input:not([type="hidden"]):not([readonly]), textarea';
  const pendingKey = 'artbite-pending-cart-v1';
  let checkingCheckout;
  let draftTimer;
  let draftStorageReadable = true;
  const restoredForms = new WeakSet();
  const customerScope = () => document.querySelector('[data-artbite-customer]')?.dataset.artbiteCustomer || 'guest';
  function clearDraft() {
    try { sessionStorage.removeItem(draftKey); sessionStorage.removeItem(pendingKey); } catch (error) {}
    clearTimeout(draftTimer);
    resetForms();
  }
  function readDraft() {
    try {
      const raw = sessionStorage.getItem(draftKey);
      draftStorageReadable = true;
      const draft = JSON.parse(raw || 'null');
      if (!draft) return null;
      if (draft.version !== 1 || !Number.isFinite(draft.expiresAt) || draft.expiresAt <= Date.now() || draft.customer !== customerScope()) {
        clearDraft();
        return null;
      }
      return draft;
    } catch (error) { draftStorageReadable = false; return null; }
  }
  function scheduleExpiry(draft) {
    clearTimeout(draftTimer);
    draftTimer = setTimeout(clearDraft, Math.max(0, draft.expiresAt - Date.now()));
  }
  function saveDraft() {
    const forms = {};
    document.querySelectorAll(formSelector).forEach((form) => {
      forms[form.id] = {};
      form.querySelectorAll(fieldSelector).forEach((field) => {
        const key = field.name || field.id;
        if (key) forms[form.id][key] = field.value;
      });
    });
    const delivery = document.querySelector('#artbite-delivery-form-wrap');
    const pickup = document.querySelector('#artbite-pickup-form-wrap');
    const draft = { version: 1, customer: customerScope(), expiresAt: Date.now() + draftTTL, forms,
      method: delivery && !delivery.hidden ? 'delivery' : pickup && !pickup.hidden ? 'pickup' : '' };
    try { sessionStorage.setItem(draftKey, JSON.stringify(draft)); } catch (error) {}
    scheduleExpiry(draft);
  }
  function restoreDraft(force = false) {
    const draft = readDraft();
    if (force && !draft && draftStorageReadable) resetForms();
    document.querySelectorAll(formSelector).forEach((form) => {
      if (!force && restoredForms.has(form)) return;
      restoredForms.add(form);
      form.querySelectorAll('[type="submit"]').forEach((button) => {
        button.disabled = false;
        if (button.dataset.originalText) button.textContent = button.dataset.originalText;
      });
      if (!draft?.forms?.[form.id]) return;
      form.querySelectorAll(fieldSelector).forEach((field) => {
        const value = draft.forms[form.id][field.name || field.id];
        if (typeof value === 'string') field.value = value;
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      });
      form.querySelectorAll('[data-delivery-error]').forEach((error) => { error.hidden = true; });
      if (draft.method) {
        const gate = form.closest('.artbite-checkout-gate');
        gate.querySelector('#artbite-delivery-form-wrap').hidden = draft.method !== 'delivery';
        gate.querySelector('#artbite-pickup-form-wrap').hidden = draft.method !== 'pickup';
        gate.querySelectorAll('.artbite-method-button').forEach((button, index) => {
          button.classList.toggle('selected', index === (draft.method === 'delivery' ? 0 : 1));
        });
      }
    });
    if (draft) scheduleExpiry(draft);
  }
  ['input', 'change'].forEach((type) => document.addEventListener(type, (event) => {
    if (event.target.closest(formSelector)) saveDraft();
  }));
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-artbite-new-order]')) clearDraft();
    else if (event.target.closest('.artbite-method-button')) saveDraft();
  });
  async function reconcileCheckout() {
    if (checkingCheckout) return checkingCheckout;
    checkingCheckout = (async () => {
      let pending;
      let before;
      try {
        pending = sessionStorage.getItem(pendingKey);
        before = sessionStorage.getItem(draftKey);
        if (!pending) return;
        const record = JSON.parse(pending);
        if (!record.id || Date.now() - record.createdAt > draftTTL) return;
        const response = await fetch('/api/2026-10/graphql.json', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: 'query DraftCartState($id: ID!) { cart(id: $id) { id } }', variables: { id: record.id } })
        });
        if (!response.ok) return;
        const result = await response.json();
        if (!result.errors?.length && result.data && result.data.cart === null &&
            sessionStorage.getItem(pendingKey) === pending && sessionStorage.getItem(draftKey) === before) clearDraft();
      } catch (error) {}
    })();
    try { await checkingCheckout; } finally { checkingCheckout = null; }
  }
  window.addEventListener('pageshow', async () => { await reconcileCheckout(); restoreDraft(true); });
  document.addEventListener('visibilitychange', async () => { if (!document.hidden) { await reconcileCheckout(); restoreDraft(true); } });
  async function startDrafts() {
    await reconcileCheckout();
    restoreDraft();
    new MutationObserver(() => restoreDraft()).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startDrafts, { once: true });
  else startDrafts();
  const mutation = `mutation PickupTestCart($input: CartInput!) {
    cartCreate(input: $input) {
      cart { id checkoutUrl totalQuantity buyerIdentity { preferences { delivery { deliveryMethod pickupHandle } } } }
      userErrors { field message }
      warnings { code message }
    }
  }`;
  async function checkoutWithMethod(cart, method) {
    if (!cart.items.length || cart.items.length > 250) throw new Error('Unsupported cart size');
    const pairs = (values) => Object.entries(values || {})
      .filter(([, value]) => value !== null && value !== undefined && String(value) !== '')
      .map(([key, value]) => ({ key, value: String(value) }));
    const input = {
      lines: cart.items.map((item) => {
        const line = {
          merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
          quantity: item.quantity,
          attributes: pairs(item.properties)
        };
        if (item.selling_plan_allocation) {
          line.sellingPlanId = 'gid://shopify/SellingPlan/' + item.selling_plan_allocation.selling_plan.id;
        }
        return line;
      }),
      attributes: pairs(cart.attributes),
      note: cart.note || '',
      discountCodes: [...new Set((cart.cart_level_discount_applications || [])
        .concat(cart.items.flatMap((item) => (item.line_level_discount_allocations || [])
          .map((allocation) => allocation.discount_application)))
        .filter((discount) => discount.type === 'discount_code')
        .map((discount) => discount.title))],
      buyerIdentity: {
        countryCode: 'CA',
        preferences: { delivery: method === 'PICK_UP'
          ? { deliveryMethod: ['PICK_UP'], pickupHandle: ['78742487088'] }
          : { deliveryMethod: ['SHIPPING'] } }
      }
    };
    if (method === 'SHIPPING' && cart.attributes?.['Recipient Address']) {
      const value = (key) => String(cart.attributes[key] || '').trim();
      const rawPhone = value('Recipient Phone');
      const digits = rawPhone.replace(/\D/g, '');
      const phone = rawPhone.startsWith('+') ? '+' + digits
        : digits.length === 10 ? '+1' + digits
        : digits.length === 11 && digits.startsWith('1') ? '+' + digits : rawPhone;
      input.delivery = {
        addresses: [{
          selected: true,
          oneTimeUse: true,
          address: {
            deliveryAddress: {
              firstName: value('Recipient First Name'),
              lastName: value('Recipient Last Name'),
              company: value('Recipient Company'),
              phone,
              address1: value('Recipient Address'),
              address2: value('Recipient Unit'),
              city: value('Recipient City'),
              provinceCode: value('Recipient Province') || 'BC',
              countryCode: 'CA',
              zip: value('Recipient Postal Code').toUpperCase()
            }
          }
        }]
      };
    }
    const response = await fetch('/api/2026-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: mutation, variables: { input } })
    });
    if (!response.ok) throw new Error('Checkout unavailable');
    const result = await response.json();
    const created = result.data && result.data.cartCreate;
    if (result.errors?.length || !created?.cart || created.userErrors.length || created.warnings?.length) {
      throw new Error('Cart could not be transferred completely');
    }
    if (created.cart.totalQuantity !== cart.item_count) throw new Error('Cart quantity mismatch');
    const preference = created.cart.buyerIdentity.preferences.delivery;
    if (!preference.deliveryMethod.includes(method) ||
        (method === 'PICK_UP' && !preference.pickupHandle.includes('78742487088'))) {
      throw new Error('Delivery preference was not saved');
    }
    const checkout = new URL(created.cart.checkoutUrl);
    if (checkout.protocol !== 'https:') throw new Error('Invalid checkout URL');
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ id: created.cart.id, createdAt: Date.now() })); } catch (error) {}
    window.location.assign(checkout.href);
  }
  window.artbitePickupCheckout = function (cart) { return checkoutWithMethod(cart, 'PICK_UP'); };
  window.artbiteDeliveryCheckout = function (cart) { return checkoutWithMethod(cart, 'SHIPPING'); };
}());
